import type { BoxProps } from "@qws-org/ui-kit";
import { Flex } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Action, MainBannerV4 as MainBannerV4Type, Pages } from "~/core";
import type { ImageParams } from "~/shared/utils/directus/useDirectus";
import { getPictureData } from "~/shared/utils/get-picture-data";

import { MainBannerV4Buttons } from "./components/MainBannerV4Buttons";
import { TextContent } from "./components/TextContent";

export type MainBannerV4Props = {
  data: MainBannerV4Type;
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
  getImageUrl: (imageId: string, params?: ImageParams) => string;
  isControlInactive: (control: Action) => boolean;
} & BoxProps;

export const MainBannerV4: FC<MainBannerV4Props> = (props) => {
  const { data, getImageUrl, ...rest } = props;

  const bg = getPictureData(data?.background);
  return (
    <Flex
      width="100%"
      justify={"center"}
      height={bg.mHeight}
      bg={
        bg.id
          ? getImageUrl(bg.id, {
              width: bg.mWidth,
              height: bg.mHeight,
              format: "webp",
              fit: "inside",
            })
          : bg.mColor
      }
      {...rest}
      md={{
        justify: "normal",
        bg: bg.mdId
          ? getImageUrl(bg.mdId, {
              width: bg.mdWidth,
              height: bg.mdHeight,
              format: "webp",
              fit: "inside",
            })
          : bg.mdColor,
        maxWidth: 1024,
        height: bg.mdHeight,

        ...rest.md,
      }}
      d={{
        bg: bg.dId
          ? getImageUrl(bg.dId, {
              width: bg.dWidth,
              height: bg.dHeight,
              format: "webp",
              fit: "inside",
            })
          : bg.dColor,

        justify: "center",
        maxWidth: 1920,
        height: bg.dHeight,
        ...rest.d,
      }}
    >
      <Flex maxWidth={1240} width={"100%"} justify={"center"}>
        <Flex
          flexDirection="column"
          width={"100%"}
          justify={"center"}
          md={{ gap: 64 }}
          gap={0}
          m={{ mt: 0 }}
          p={{ px: 16 }}
        >
          <TextContent
            title={data?.title}
            description={data?.description}
            items={data?.list_items}
          />

          {data?.controls && <MainBannerV4Buttons {...props} />}
        </Flex>
      </Flex>
    </Flex>
  );
};
